<template>
    <div class="estadisticas">
        <div class="content">
            <div class="titulo">
                <b-row>
                    <b-col cols="12" md>
                        <div class="linea lineaIzquierda"></div>
                    </b-col>
                    <b-col cols="12" md="auto">
                        <p v-if="lang == 'eng'">statistics</p>
                        <p v-else-if="lang == 'esp'">estadísticas</p>
                    </b-col>
                    <b-col cols>
                        <div class="linea lineaDerecha"></div>
                    </b-col>
                </b-row>
            </div>
            <b-row>
                <b-col cols="12" md="4">
                    <img src="../assets/img/img_garita1.jpg" alt="Garita">
                    <div class="text" v-if="lang == 'eng'">
                        <p>Vehicular Digital Screen Chaparral Checkpoint</p>
                        <h5>1.4 million</h5>
                        <p>Monthly Potential<br>Leads</p>
                    </div>
                     <div class="text" v-else-if="lang == 'esp'">
                        <p>Pantalla Vehicular Garita Chaparral</p>
                        <h5>1.4 millones</h5>
                        <p>Alcances Potenciales<br>Mensuales</p>
                    </div>
                </b-col>
                <b-col cols="12" md="4" class="pantallaCentro">
                    <img src="../assets/img/img_garita2.jpg" alt="Garita">
                    <div class="text" v-if="lang == 'eng'">
                        <p>Pedestrian Digital Screen Chaparral Checkpoint</p>
                        <h5>200 K</h5>
                        <p>Monthly Potential<br>Leads</p>
                    </div>
                     <div class="text" v-else-if="lang == 'esp'">
                        <p>Pantalla Peatonal Garita Chaparral</p>
                        <h5>200 K</h5>
                        <p>Alcances Potenciales<br>Mensuales</p>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <img src="../assets/img/img_garita3.jpg" alt="Garita">
                    <div class="text" v-if="lang == 'eng'">
                        <p>Vehicular Digital Screen Otay Checkpoint</p>
                        <h5>700 K</h5>
                        <p>Monthly Potential<br>Leads</p>
                    </div>
                     <div class="text" v-else-if="lang == 'esp'">
                        <p>Pantalla Vehicular Garita Otay</p>
                        <h5>700 K</h5>
                        <p>Alcances Potenciales<br>Mensuales</p>
                    </div>
                </b-col>
                <b-col cols="12">
                    <p class="info" v-if="lang == 'eng'">INFORMATION TAKEN FROM <a href="https://www.bts.gov/" target="_blank">BTS.GOV</a> AS OF SEPTEMBER 2020</p>
                    <p class="info" v-else-if="lang == 'esp'">INFORMACIÓN TOMADA DE <a href="https://www.bts.gov/" target="_blank">BTS.GOV</a> A SEPTIEMBRE 2020</p>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    export default {
        computed:{
            ...mapState(['lang'])
        }
    }
</script>

<style scoped>
    .estadisticas{
        padding-top: 140px;
        text-align: center;
    }
    img{
        width: 100%;
    }
    .text{
        background-color: #EF4E28;
        padding: 20px 10px;
    }
    .text *{
        color: white;
    }
    .text p{
        font-size: 10pt;
        margin-bottom: 5px;
    }
    .text h5{
        font-family: 'sailecBlack';
    }
    .info{
        margin-top: 40px;
    }
    .info a{
        color: #EF4E28;
    }

    @media screen and (max-width: 767px){
        .estadisticas{
            padding-top: 100px;
        }
        .pantallaCentro{
            margin: 40px 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Estadisticas.vue